<!-- vertical layout -->
<app-vertical-layout [layoutWidth]="layoutWidth">
</app-vertical-layout>
<ngx-spinner name="global"  bdColor = "rgba(0, 0, 0, 0.9)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Ładuje... </p></ngx-spinner>

<!-- "What's new" announcement modal -->
<ng-template #whatsNewModal let-modal>
    <div class="whats-new">
        <button type="button" class="whats-new__close" aria-label="Zamknij" (click)="modal.dismiss()">
            <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="whats-new__hero">
            <div class="whats-new__badge"><i class="fi fi-rr-rocket"></i> Aktualizacja</div>
            <h3 class="whats-new__title">Co nowego w Fodimi?</h3>
            <p class="whats-new__subtitle">
                W ostatnich dniach dorzuciliśmy sporo nowych funkcji — od nowego pulpitu, przez karty rabatowe,
                po faktury i magazyn. Oto najważniejsze nowości:
            </p>
        </div>

        <div class="whats-new__body">
            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-dashboard"></i></div>
                <div class="whats-new__text">
                    <h5>Nowy pulpit</h5>
                    <p>Dzień, tydzień albo miesiąc w jednym miejscu: sprzedaż, kanały zamówień, formy płatności
                        i porównanie lokali. Na pierwszy rzut oka widzisz, jak idzie biznes.</p>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-id-badge"></i></div>
                <div class="whats-new__text">
                    <h5>Karty rabatowe</h5>
                    <p>Stały rabat dla pracowników, firm partnerskich albo studentów. Każda osoba dostaje własną
                        kartę z kodem QR — skanujesz ją na kasie i w kiosku, a online wystarczy wpisać numer karty.
                        Klient zawsze dostaje najkorzystniejszy rabat.</p>
                    <a href="https://pomoc.fodimi.pl/marketing/karty-rabatowe" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-qrcode"></i></div>
                <div class="whats-new__text">
                    <h5>Kupony z kodem QR</h5>
                    <p>Kupony ukryte w aplikacji, które drukujesz jako kody QR — np. na ulotki albo do rozdania gościom.
                        Kody jednorazowe lub wielorazowe, realizowane na kasie i w kiosku.</p>
                    <a href="https://pomoc.fodimi.pl/marketing/kupony-z-kodem-qr" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-file-invoice"></i></div>
                <div class="whats-new__text">
                    <h5>Więcej możliwości przy fakturach</h5>
                    <p>Faktury dla firm wystawisz z panelu także bez rachunku na kasie. Doszły korekty faktur,
                        faktury imienne do paragonu oraz faktury dla firm zagranicznych — ze sprawdzaniem numeru VAT
                        w VIES i PDF po polsku i angielsku.</p>
                </div>
            </div>

            <div class="whats-new__item" *ngIf="hasInventory">
                <div class="whats-new__icon"><i class="fi fi-rr-boxes"></i></div>
                <div class="whats-new__text">
                    <h5>Spis z natury i korekty PZ</h5>
                    <p>Roczny spis z natury dla księgowej przygotujesz prosto z inwentaryzacji — z wyceną, PDF,
                        eksportem do Excela i protokołem różnic. Błędne dostawy poprawisz korektą PZ, a stany
                        i średnie ceny przeliczą się same.</p>
                    <a href="https://pomoc.fodimi.pl/magazyn/spis-z-natury" target="_blank" rel="noopener">
                        Zobacz, jak zrobić spis <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-plug-connection"></i></div>
                <div class="whats-new__text">
                    <h5>Klucze API i webhooki</h5>
                    <p>Masz własny system albo integratora? W Integracjach wygenerujesz klucze API z uprawnieniami
                        i ustawisz webhooki, które na bieżąco powiadomią Twój system o zamówieniach.</p>
                </div>
            </div>
        </div>

        <div class="whats-new__footer">
            <button type="button" class="btn btn-primary btn-lg whats-new__cta" (click)="modal.close()">
                Świetnie, zaczynam!
            </button>
        </div>
    </div>
</ng-template>
